import trList from '@/components/trList'
import equipmentDetail from '@/components/equipmentDetail'
import floatIcon from '@/components/floatIcon'
import wxPay from '@/components/wxPay'
import trLoading from "_com/trLoading/index.vue";
export default (Vue) => {
  Vue.component('trList', trList)
  Vue.component('equipmentDetail', equipmentDetail)
  Vue.component('floatIcon', floatIcon)
  Vue.component('wxPay', wxPay)
  Vue.component('trLoading', trLoading)
}
